<style lang="scss" scoped>
.logon-bg {
	padding: 0px;
	background-color: #192A3E;
	display: flex;
	flex-flow: column nowrap;
}
.logon-icon {
	width: 120%;
	height: 20%;
}
.logon-icon-bg {
	background-color: #FFFFFF;
	height: 100%;
	border-radius: 0 0 50% 50%;
	display: flex;
	flex-flow: column-reverse;
}
.logon-container {
	height: 80%;
	width: 350px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-between;
}
.whitelink {
	color: #FFFFFF;
}
.error-text {
	color: #F45252;
}
.correct-color {
	color: #00AAFD;
}
.welcome-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 20px;
	line-height: 32px;
	width: 100%;
}
.error-message {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.4px;
	color: #F45252;
}
.authentication-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	letter-spacing: 0.25px;
}
.two-btn {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.tooltip-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	text-align: center;
	letter-spacing: 0.25px;
	color: #F45252;
}
.set2fa {
	display: flex;
	flex-flow: column nowrap;
	background: #FAFAFA;
	border-radius: 4px;
	&:hover {
		cursor: pointer;
	}
}
.set2fa-title {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	letter-spacing: -0.5px;
	color: #00AAFD;
}
.set2fa-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.4px;
	color: #192A3E;
}
.help-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	text-decoration-line: underline;
}
.warning-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	letter-spacing: 0.5px;
}

::v-deep {
	.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
		background-color: #C4C4C4 !important;
	}
	.theme--light.v-btn.v-btn--disabled {
    color: #FFFFFF !important;
	}
	.theme--light.v-btn.v-btn--disabled .v-icon {
		color: #FFFFFF !important;
	}
	.text-field-style.theme--light.v-input input {
		color: red
	}
	.text-field-style.v-text-field.v-text-field--enclosed .v-text-field__details {
		padding: 0;
		margin-bottom: 0;
	}
}
</style>

<template>
	<v-container fluid fill-height class="logon-bg pb-5">
		<div class="logon-icon">
			<div class="logon-icon-bg">
				<div class="text-center mb-3">
					<jbicon :width="54" :height="54"></jbicon>
					<div class="text-center grey--text" style="font-size: 24px">
						JobBag
					</div>
				</div>
			</div>
		</div>
		<div class="logon-container" @keydown="e => check_caps(e)">
			<div>
				<v-alert type="error" v-if="errormsg.length !== 0" dense class="my-1 py-1">{{ errormsg }}</v-alert>
				<div class="text-center white--text welcome-text my-2">
					<span v-if="entry_mode === entry_mode_status.set2fa">Reset Two Factor Authentication</span>
					<span v-else-if="entry_mode === entry_mode_status.totp">Two Factor Authentication</span>
					<span v-else-if="entry_mode === entry_mode_status.email">Authenticating...</span>
					<span v-else-if="entry_mode === entry_mode_status.renewPwd">Password reset</span>
					<span v-else>Welcome back</span>
				</div>
				<v-form v-if="entry_mode === entry_mode_status.logon" @submit.prevent="do_logon">
					<div class="authentication-text whitelink">
						User name
					</div>
					<v-text-field
						v-model="username"
						solo dense hide-details
						ref="username"
						:disabled="loading"
						autocomplete="off"
						background-color="#FAFAFA"
					/>
					<div class="authentication-text" :class="errormsg.length !== 0 ? 'error-text':'whitelink'">
						Password
					</div>
					<v-text-field
						id="password"
						v-model="password"
						:class="errormsg.length !== 0 ? 'text-field-style':''"
						solo
						dense
						hide-details
						background-color="#FAFAFA"
						:disabled="loading"
						color="rgba(0, 0, 0, 0.54)"
						:append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
						:type="show_password ? 'text' : 'password'"
						:error="errormsg.length !== 0"
						@click:append="show_password = !show_password"
					/>
					<div v-if="errormsg.length !== 0" class="error-message">Wrong password, try again</div>
					
					<v-tooltip v-if="capslock" v-model="capslock" :activator="'#password'" bottom color="#FFFFFF">
						<span class="tooltip-text">Caps Lock is on</span>
					</v-tooltip>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<div v-if="!loading">
						<div>
							<v-btn 
								:disabled="username.length === 0 || password.length === 0" 
								block
								type="submit"
								class="white--text text-capitalize" 
								color="#00AAFD">
								Next
								<v-icon small class="ml-2">mdi-arrow-right</v-icon>
							</v-btn>
						</div>
						<div class="mt-4">
							<v-btn dark text block type="submit" class="text-capitalize" @click.prevent="show_reset_password">Forgot Password?</v-btn>
						</div>
					</div>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div>
				</v-form>

				<v-form v-if="entry_mode === entry_mode_status.set2fa" @submit.prevent="do_set_2fa">
					<div class="authentication-text whitelink mb-2">
						<span>How would you like to receive your authentication codes?</span>
					</div>
					<v-row no-gutters class="set2fa pa-3 mx-0 mt-0 mb-3" @click="onSet2faClick(mode_2fa_key.totp)">
						<v-row no-gutters class="ma-0">
							<v-icon color="#00AAFD" class="mr-4">mdi-lock</v-icon>
							<div class="set2fa-title">Use an Authenticator app</div>
						</v-row>
						<div class="set2fa-text">Retrieve codes from an authentication app on your mobile device, such as Google Authenticator or FreeOTP.</div>
					</v-row>
					<v-row no-gutters class="set2fa pa-3 ma-0" @click="onSet2faClick(mode_2fa_key.email)">
						<v-row no-gutters class="ma-0">
							<v-icon color="#00AAFD" class="mr-4">mdi-email-outline</v-icon>
							<div class="set2fa-title">Email it to me</div>
						</v-row>
						<div class="set2fa-text">Receive your code in an email to at your registered email address when signing in.</div>
					</v-row>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div> 
				</v-form>

				<v-form v-if="entry_mode === entry_mode_status.email" @submit.prevent="do_step_two">
					<div class="authentication-text whitelink">
						Email security code:
					</div>
					<v-text-field
						v-model="challenge_code"
						solo
						dense
						hide-details
						clearable
						ref="email_code"
						:disabled="loading"
						:error="errormsg.length !== 0 && challenge_code.length !== 0"
						:class="errormsg.length !== 0 && challenge_code.length !== 0 ? 'text-field-style':''"
						color="rgba(0, 0, 0, 0.54)"
						background-color="#FAFAFA"
					/>
					<div v-if="errormsg.length !== 0 && challenge_code.length !== 0" class="error-message">Code is incorrect</div>
					<v-row no-gutters class="mx-0 mb-0 mt-1" v-if="time_out">
						<v-col cols="1" class="mr-2">
							<WarningIcon :width="20" :height="20"/>
						</v-col>
						<v-col cols="10">
							<div class="warning-text whitelink">
								If you didn’t receive a code, please contact your system administrator to verify your email address and reset your 2 Factor Authentication
							</div>
						</v-col>
					</v-row>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<v-row no-gutters class="mx-0 my-2" v-if="!loading">
						<v-btn class="white--text text-capitalize" :disabled="challenge_code.length === 0" block color="#00AAFD" type="submit">
							Sign in
							<v-icon small class="ml-2">mdi-arrow-right</v-icon>
						</v-btn>
					</v-row>
					<v-row no-gutters class="ma-0" v-if="!loading && time_out">
						<v-btn class="text-capitalize" dark block outlined @click.prevent="back_to_logon">
							<v-icon small class="mr-2">mdi-arrow-left</v-icon>
							Back to login
						</v-btn>
					</v-row>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div>
				</v-form>

				<v-form v-if="entry_mode === entry_mode_status.totp" @submit.prevent="do_step_two">
					<div v-if="qrcode.length !== 0">
						<div class="authentication-text whitelink mb-2">
							<span>Scan the image below with your authenticator app.</span>
						</div>
						<v-row no-gutters class="ma-0" justify="center">
							<v-qrcode :qrcode="qrcode" :cellSize="$vuetify.breakpoint.mobile ? 2:3"/>
						</v-row>
						<v-row no-gutters class="ma-0" justify="center">
							<v-btn text dense plain link :href="help_url" target="_blank" color="#C4C4C4" class="text-capitalize">
								<span class="help-text">Unsure how to do this?</span>
							</v-btn>
						</v-row>
					</div>
					<div class="authentication-text whitelink">
						<span>Two factor authentication code:</span>
					</div>
					<v-text-field
						class="mb-2"
						v-model="challenge_code"
						solo
						dense
						hide-details
						clearable
						ref="totp_code"
						:disabled="loading"
						:error="errormsg.length !== 0 && challenge_code.length !== 0"
						:class="errormsg.length !== 0 && challenge_code.length !== 0 ? 'text-field-style':''"
						color="rgba(0, 0, 0, 0.54)"
						background-color="#FAFAFA"
					/>
					<div v-if="errormsg.length !== 0" class="error-message">Code is incorrect</div>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<v-row v-if="!loading && qrcode.length !== 0" no-gutters class="ma-0">
						<v-btn class="white--text text-capitalize" :disabled="challenge_code.length === 0" block color="#00AAFD" type="submit">
							Sign in
							<v-icon small class="ml-2">mdi-arrow-right</v-icon>
						</v-btn>
						<v-row no-gutters class="mx-0 mb-0 mt-1" v-if="challenge_code.length === 0">
							<v-col cols="1" class="mr-2">
								<WarningIcon :width="20" :height="20"/>
							</v-col>
							<v-col cols="10">
								<div class="warning-text whitelink">If you didn’t receive a code, please contact your system administrator to verify your email address and reset your 2 Factor Authentication</div>
							</v-col>
						</v-row>
					</v-row>
					<v-row v-if="!loading && qrcode.length === 0" no-gutters class="two-btn ma-0">
						<v-btn class="text-capitalize" width="calc(50% - 4px)" dark outlined @click.prevent="back_to_logon">
							<v-icon small class="mr-2">mdi-arrow-left</v-icon>
							Back
						</v-btn>
						<v-btn class="white--text text-capitalize" width="calc(50% - 4px)" :disabled="challenge_code.length === 0" color="#00AAFD" type="submit">
							Sign in
							<v-icon small class="ml-2">mdi-arrow-right</v-icon>
						</v-btn>
					</v-row>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div>
				</v-form>

				<v-form v-if="entry_mode === entry_mode_status.renewPwd" @submit.prevent="do_renew_password">
					<div class="warning-text whitelink mb-1">
						Your password has expired, please provide a new password.
					</div>
					<div class="authentication-text" :class="errormsg.length !== 0 ? 'error-text':'whitelink'">
						New Password
					</div>
					<v-text-field
						id="new_password"
						v-model="new_password"
						:class="errormsg.length !== 0 ? 'text-field-style':''"
						solo
						dense
						hide-details
						background-color="#FAFAFA"
						:disabled="loading"
						color="rgba(0, 0, 0, 0.54)"
						:append-icon="show_new_password ? 'mdi-eye' : 'mdi-eye-off'"
						:type="show_new_password ? 'text' : 'password'"
						:error="errormsg.length !== 0"
						@click:append="show_new_password = !show_new_password"
					/>
					<v-row no-gutters class="mx-0 my-2">
						<v-col cols="6" class="warning-text" :class="password_set.includes(password_Key.uppercase) ? 'correct-color':'whitelink'">
							Upper case character
							<v-icon x-small color="#00AAFD" v-if="password_set.includes(password_Key.uppercase)">mdi-check</v-icon>
						</v-col>
						<v-col cols="6" class="warning-text" :class="password_set.includes(password_Key.lowercase) ? 'correct-color':'whitelink'">
							Lower case character
							<v-icon x-small color="#00AAFD" v-if="password_set.includes(password_Key.lowercase)">mdi-check</v-icon>
						</v-col>
						<v-col cols="6" class="warning-text" :class="password_set.includes(password_Key.number) ? 'correct-color':'whitelink'">
							Number
							<v-icon x-small color="#00AAFD" v-if="password_set.includes(password_Key.number)">mdi-check</v-icon>
						</v-col>
						<v-col cols="6" class="warning-text" :class="password_set.includes(password_Key.special) ? 'correct-color':'whitelink'">
							Special character(&nbsp;!@#$...&nbsp;)
							<v-icon x-small color="#00AAFD" v-if="password_set.includes(password_Key.special)">mdi-check</v-icon>
						</v-col>
						<v-col cols="6" class="warning-text" :class="password_set.includes(password_Key.minimum) ? 'correct-color':'whitelink'">
							Minimum <b>{{ password_length }}</b> characters
							<v-icon x-small color="#00AAFD" v-if="password_set.includes(password_Key.minimum)">mdi-check</v-icon>
						</v-col>
					</v-row>
					<div class="authentication-text" :class="errormsg.length !== 0 || confirm_errormsg.length !== 0 ? 'error-text':'whitelink'">
						Confirm Password
					</div>
					<v-text-field
						id="confirm_password"
						v-model="confirm_password"
						:class="errormsg.length !== 0 || confirm_errormsg.length !== 0 ? 'text-field-style':''"
						solo
						dense
						:hide-details="confirm_errormsg.length === 0"
						background-color="#FAFAFA"
						:disabled="loading"
						color="rgba(0, 0, 0, 0.54)"
						:append-icon="show_confirm_password ? 'mdi-eye' : 'mdi-eye-off'"
						:type="show_confirm_password ? 'text' : 'password'"
						:error="errormsg.length !== 0 || confirm_errormsg.length !== 0"
						:error-messages="confirm_errormsg"
						@click:append="show_confirm_password = !show_confirm_password"
					/>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<v-row v-if="!loading" class="mt-2">
						<v-col cols="6">
							<v-btn class="text-capitalize" dark block outlined @click.prevent="back_to_logon">
								<v-icon small class="mr-2">mdi-arrow-left</v-icon>
								Back
							</v-btn>
						</v-col>
						<v-col cols="6">
							<v-btn class="white--text text-capitalize" :disabled="!(new_password.length !== 0 && confirm_password.length !== 0 && new_password === confirm_password)" block color="#00AAFD" type="submit">
								Sign in
								<v-icon small class="ml-2">mdi-arrow-right</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div>
				</v-form>

				<v-form v-if="entry_mode === entry_mode_status.passwordReset" @submit.prevent="do_reset_password">
					<div class="authentication-text whitelink">
						User name
					</div>
					<v-text-field
						v-model="username"
						solo dense hide-details
						ref="reset_username"
						:disabled="loading"
						background-color="#FAFAFA"
						class="mb-4"
					/>
					<div class="authentication-text whitelink">
						Confirm your email address
					</div>
					<v-text-field
						v-model="email"
						solo dense hide-details
						:disabled="loading"
						background-color="#FAFAFA"
						class="mb-4"
					/>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
					<v-row v-if="!loading" class="mt-2">
						<v-col cols="6">
							<v-btn class="text-capitalize" dark block outlined @click.prevent="back_to_logon">
								<v-icon small class="mr-2">mdi-arrow-left</v-icon>
								Back
							</v-btn>
						</v-col>
						<v-col cols="6">
							<v-btn class="white--text text-capitalize" block :disabled="username.length === 0 || email.length === 0" color="#00AAFD" type="submit">
								Reset
								<v-icon small class="ml-2">mdi-arrow-right</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<div v-if="loading" class="text-right">
						<v-progress-circular color="white"
							indeterminate
						></v-progress-circular>
					</div>
				</v-form>

				<v-form v-if="entry_mode == entry_mode_status.confirmPasswordReset">
					<div class="white--text">
						An email with a password reset link has been sent to the nominated email address.
					</div>
					<div>
						<v-btn small @click.prevent="back_to_logon">
							<v-icon small class="mr-2">mdi-arrow-left</v-icon>
							Back
						</v-btn>
					</div>
					<div class="caption white--text text-center my-4">
						By signing in you agree to the <a class="whitelink" href="https://jobbag.com/privacy-policy/" target="_blank">Privacy Policy</a>
					</div>
				</v-form>
			</div>
			<div v-if="entry_mode !== entry_mode_status.set2fa && entry_mode !== entry_mode_status.totp && entry_mode !== entry_mode_status.email && entry_mode !== entry_mode_status.renewPwd" :class="$vuetify.breakpoint.xs ? 'd-none':''">
				<v-row class="ma-0 px-3" align="center">
					<v-divider style="border-color: #C4C4C4"></v-divider>
					<div class="mx-3 white--text warning-text">Or sign in with</div>
					<v-divider style="border-color: #C4C4C4"></v-divider>
				</v-row>
				<v-row class="my-3" justify="center">
					<v-btn outlined fab class="rounded" color="#FFFFFF" style="border-color: #C4C4C4" @click="onAppStream()">
						<AppStreamIcon />
					</v-btn>
				</v-row>
				<v-row class="ma-0" justify="center">
					<div class="white--text warning-text">Appstream</div>
				</v-row>
			</div>
			<div v-if="entry_mode !== entry_mode_status.set2fa && entry_mode !== entry_mode_status.totp && entry_mode !== entry_mode_status.email && entry_mode !== entry_mode_status.renewPwd" class="mt-3" :class="$vuetify.breakpoint.xs ? 'd-none':''">
				<div class="subtitle-1 text-center" style="color: white;">
					Download desktop version:
				</div>
				<v-row no-gutters class="two-btn mt-1">
					<v-btn
						outlined
						color="white"
						:href="installer_links.mac_installer"
						width="calc(50% - 4px)"
					>
						<v-icon left>{{ apple }}</v-icon>
						<span>macOS</span>
					</v-btn>
					<v-btn
						outlined
						color="white"
						:href="installer_links.windows_installer"
						width="calc(50% - 4px)"
					>
						<v-icon left>{{ windows }}</v-icon>
						<span>Windows</span>
					</v-btn>
				</v-row>
			</div>
		</div>
	</v-container>
</template>

<script>
import { mdiApple, mdiWindows, mdiNumeric } from "@mdi/js";
import jbicon from "@/components/icons/jobbag-icon";
import WarningIcon from "@/components/icons/warning";
import AppStreamIcon from "@/components/icons/appstream";
import { serverChecker } from "@/common/regionRedirect.js";

const Entry_Mode_Status = {
	email: 'Email',
	totp: 'TOTP',
	set2fa: 'Set2fa',
	renewPwd: 'RenewPwd',
	logonToken: 'LogonToken',
	fail: 'FAIL',
	logon: 'Logon',
	passwordReset: 'password_reset',
	confirmPasswordReset: 'confirm_password_reset'
};

const MODE_2FA = {
	email: 1,
	totp: 2
};

const HELP_URL = 'https://help.jobbag.com/docs/2fa';

const Password_Set = {
	uppercase: 'uppercase',
	lowercase: 'lowercase',
	number: 'number',
	special: 'special',
	minimum: 'minimum'
};

export default {
	name: 'LogonForm',
	data() {
		this.entry_mode_status = Entry_Mode_Status;
		this.mode_2fa_key = MODE_2FA;
		this.password_Key = Password_Set;
		
		return {
			loading: false,
			capslock: false,
			entry_mode: Entry_Mode_Status.logon,
			errormsg: "",
			confirm_errormsg: '',
			username: "",
			password: "",
			show_password: false,
			password_length: 5,
			email: "",
			challenge_key: '',
			challenge_code: "",
			qrcode: "",
			mode_2fa: 0,
			help_url: HELP_URL, 
			
			new_password: "",
			show_new_password: false,
			confirm_password: "",
			show_confirm_password: false,
			password_set: [],
			installer_links: {
				windows_installer: "",
				mac_installer: ""
			},
			apple: mdiApple,
			windows: mdiWindows,
			numeric: mdiNumeric,

			time_out: false,
			tid: null,
		};
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	created() {
		this.get_download_links();
	},
	mounted() {
		this.$refs.username.focus();

		/* document360-widget-iframe, or beacon-container */
		const widget_name_str = 'beacon-container';

		/* to keep widget non-showing */
		const child = document.getElementById(widget_name_str);	

		if (child) {
			child.style.display = 'none';
		}	else {
			const body_arr = document.getElementsByTagName('body');
			const target_node = body_arr[0];
			const config = { childList: true};
			let isIframe = false;

			const callback = (mutationsList) => {
				mutationsList.forEach((item) => {
					if (item.type == 'childList') {
						const childNodes = item.target.childNodes;
						childNodes.forEach(c => {
							if (c.id === widget_name_str) {
								isIframe = true;
								const child_new = document.getElementById(widget_name_str);
								child_new.style.display = 'none';
							}
						});
					}
				});
			};

			const observer = new MutationObserver(callback);
			observer.observe(target_node, config);
			if (isIframe) {
				observer.disconnect();
			}
		}

	}, 
	watch: {
		challenge_code() {
			if (!this.challenge_code || this.challenge_code.length === 0) {
				this.errormsg = '';
				this.challenge_code = '';
			}
		},
		password() {
			if (this.password.length === 0) {
				this.errormsg = '';
				this.password = '';
			}
		},
		new_password() {
			const test_password = this.new_password;
			const password_set_keys = [];

			// number
			const pattern = /\d+/;
			if (pattern.test(test_password)) {
				password_set_keys.push(Password_Set.number);
			}

			//special
			const key_arr = [ '[', '(', ')', '*','&', '^', '%', '$', '#', '@', '!', ']'];
			key_arr.forEach(k => {
				if (test_password.includes(k)) {
					if (!password_set_keys.includes(Password_Set.special)) {
						password_set_keys.push(Password_Set.special);
					}
				}
			});

			// uppercase
			if (test_password !== test_password.toLowerCase()) {
				password_set_keys.push(Password_Set.uppercase);
			}

			// lowercase
			if (test_password !== test_password.toUpperCase()) {
				password_set_keys.push(Password_Set.lowercase);
			}

			// minimum
			if (test_password.length >= this.password_length) {
				password_set_keys.push(Password_Set.minimum);
			}

			this.password_set = password_set_keys;
		},
		confirm_password() {
			this.confirm_errormsg = '';
			if (this.confirm_password.length !== 0 && this.confirm_password !== this.new_password) {
				this.confirm_errormsg = 'Passwords do not match';
			}
		}
	},
	methods: {
		check_caps(event) {
			this.capslock = event.getModifierState('CapsLock'); 
		},
		get_download_links() {
			axios
				.post("/api/installers/listbuildinfo", {
				})
				.then((d) => {
					let data = d.data;

					if (data.Status == "OK") {
						this.installer_links.windows_installer = data.Windows_installer;
						this.installer_links.mac_installer = data.Mac_installer;
					}
				});

		},
		get_password_length() {
			axios
				.get("/api/config/setup/user", {
				})
				.then((val) => {
					const {status, data} = val.data;
					if (status == "OK") {
						this.password_length = data.min_password_length;
					}
				});
		},
		back_to_logon() {
			this.errormsg = "";
			this.entry_mode = this.entry_mode_status.logon;
			this.challenge_key = "";
			this.mode_2fa = 0;
			this.challenge_code = "";
			this.password = "";
			this.new_password = "";
			this.confirm_password = "";
			this.time_out = false;

			this.$nextTick(() => {
				this.$refs.username.focus();
			})
		},
		process_results(data) {
			if (data.status === this.entry_mode_status.email) {
				this.errormsg = "";
				this.entry_mode = data.status;
				this.challenge_key = data.challenge_key;
				this.challenge_code = "";
				this.time_out = false;

				this.tid = setTimeout(this._timeOutCheck, 20000);

				this.$nextTick(() => {
					this.$refs.email_code.focus();
				});
			} else if (data.status === this.entry_mode_status.totp) {
				this.errormsg = "";
				this.entry_mode = data.status;
				this.challenge_key = data.challenge_key;
				this.challenge_code = "";
				this.time_out = false;

				if (data.new_totp_secret) {
					let issuer = location.hostname.split(".")[0];
					this.qrcode = "otpauth://totp/" + issuer + ":" + this.username + "?secret=" + data.new_totp_secret + "&issuer=" + issuer + "&algorithm=SHA1&digits=6&period=30";
				} else {
					this.qrcode = "";
				}

				this.$nextTick(() => {
					this.$refs.totp_code.focus();
				});
			} else if (data.status === this.entry_mode_status.set2fa) {
				this.errormsg = "";
				this.entry_mode = data.status;
				this.challenge_key = data.challenge_key;
				this.time_out = false;
			} else if (data.status === this.entry_mode_status.renewPwd) {
				this.errormsg = "";
				this.entry_mode = data.status;
				this.challenge_key = data.challenge_key;
				this.password_length = data.min_pwd_len;
				this.new_password = "";
				this.confirm_password = "";
				this.time_out = false;
			} else if (data.status === this.entry_mode_status.logonToken) {
				// we're logged on, need to deal with that...
				this.finish_logon(data);
			} else if (data.status === this.entry_mode_status.fail) {
				this.errormsg = data.reason;
			} else {
				this.errormsg = "Unknown status returned '" + data.status + "'";
			}
		},
		do_logon() {
			this.loading = true;

			axios
				.post("/api/user/do_logon", {
					user_name: this.username,
					password: this.password
				})
				.then((d) => {
					// !BAS! We don't use finally here because it will cause our focus to run before we rebuild our UI and unsets the focus
					this.loading = false;

					this.process_results(d.data);
				})
				.catch((e) => {
					console.log(e);
					this.loading = false;
					this.errormsg = e.message;
				});
		},
		do_set_2fa() {
			this.loading = true;

			axios
				.post("/api/user/step_2fa", {
					user_name: this.username,
					method: this.entry_mode,
					challenge_key: this.challenge_key,
					mode: this.mode_2fa,
				})
				.then((d) => {
					this.process_results(d.data);
				})
				.catch((e) => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		do_step_two() {
			this.loading = true;

			axios
				.post("/api/user/step_two", {
					user_name: this.username,
					method: this.entry_mode,
					challenge_key: this.challenge_key,
					challenge_code: this.challenge_code
				})
				.then((d) => {
					this.process_results(d.data);
				})
				.catch((e) => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		do_renew_password() {
			if (this.new_password != this.confirm_password) {
				this.errormsg = "Entered passwords do not match!"
				return;
			}

			this.loading = true;

			axios
				.post("/api/user/step_renew_pwd", {
					user_name: this.username,
					method: this.entry_mode,
					challenge_key: this.challenge_key,
					new_password: this.new_password
				})
				.then((d) => {
					this.process_results(d.data);
				})
				.catch((e) => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});

		},
		finish_logon(data) {
			// record token
			this.$store.commit("set_token", data.token);
			this.$store.dispatch('check_token');

			// clear some stuff we no longer need
			this.errormsg = "";
			this.entry_mode = this.entry_mode_status.logon;
			this.challenge_key = "";
			this.challenge_code = "";

			// get version info
			this.loading = true;
			axios
				.get("/oauth/version")
				.then((d) => {
					if (d.data.db_version == d.data.jobbag_version) {
						// navigate away
						this.$router.push(this.$store.state.redirect_after_logon);
						this.$store.commit("clear_redirect_after_logon");
					} else {
						this.$router.push('/logon/upgrade');
					}
				})
				.catch((e) => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		show_reset_password() {
			this.entry_mode = this.entry_mode_status.passwordReset;
			this.$nextTick(() => {
				this.$refs.reset_username.focus();
			});
		},
		do_reset_password() {
			this.loading = true;

			axios
				.post("/oauth/do_reset_password", {
					user_name: this.username,
					email: this.email,
				})
				.then((d) => {
					if (d.data.status === this.entry_mode_status.fail) {
						this.errormsg = d.data.reason;
					} else {
						this.entry_mode = this.entry_mode_status.confirmPasswordReset;
					}
				})
				.catch((e) => {
					console.log(e);
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});

		},
		go_to_terms() {
			this.$router.push('/logon/terms');
		},
		onSet2faClick(key) {
			this.mode_2fa = key;
			this.do_set_2fa();
		},
		onAppStream() {
			const current_hostname = window.location.hostname;
			const server = serverChecker(current_hostname);

			const link = `https://appstream2.${server.server}.aws.amazon.com/${server.pool}#/signin?ref=LtHEyAWVli`;
			window.location=link;
		},
		_timeOutCheck() {
			if (this.challenge_code.length === 0) {
				this.time_out = true;
			}
		}
	},
	components: {
		jbicon,
		WarningIcon,
		AppStreamIcon
	}
};
</script>


